module.exports = __webpack_public_path__ + "static/img/bg56.590a1a4a.png";